import "core-js/modules/es.array.concat.js";
export default (function (_ref) {
  var request = _ref.request;
  return {
    payWithdrawalQueryJoinUser: function payWithdrawalQueryJoinUser(data) {
      return request({
        url: '/pay/withdrawalOrder/queryJoinUser',
        method: 'get',
        params: data
      });
    },
    payWithdrawalDetail: function payWithdrawalDetail(id) {
      return request({
        url: "/pay/withdrawalOrder/".concat(id),
        method: 'get'
      });
    },
    payWithdrawalTransfer: function payWithdrawalTransfer(id, withdrawalTime) {
      return request({
        url: "/pay/withdrawalOrder/".concat(id, "/transfer/").concat(withdrawalTime),
        method: 'post'
      });
    },
    payWithdrawalRejected: function payWithdrawalRejected(id, msg) {
      return request({
        url: "/pay/withdrawalOrder/".concat(id, "/rejected?msg=").concat(msg),
        method: 'post'
      });
    }
  };
});